export const STORAGE_MAIN_KEY = '@etherspotWebWallet';
export const STORAGE_KEY = {
  MINTED_COLLAB_NFT_TOKEN_ID: 'mintedCollabNftTokenId',
  ADDED_COLLAB_BOT: 'addedCollabBot',
};
